import React from "react";
import scrollTo from "gatsby-plugin-smoothscroll";
import { linkFormat } from "../../utilities/linkFormat";

export default function CtaButton({ data, link, text, heroButton }) {
  return data ? (
    <button
      className="tick-pro-btn"
      onClick={() => scrollTo("#newsletter-subscription")}
    >
      {data.buttonText}
    </button>
  ) : (
    <a className="CtaButton" href={linkFormat(link)}>
      <button className={!heroButton ? "fg-btn" : "fg-btn--white font-a2"}>
        {text}
      </button>
    </a>
  );
}
